<template functional>
  <span>
    {{ $options.methods.formatDate(props.start) }}
    -
    <template v-if="props.end">{{ $options.methods.formatDate(props.end) }}</template>
    <template v-else>
      {{ parent.$t('internalstock.unlimited_information') }}
      <!-- #S825 -->
    </template>
  </span>
</template>

<script>
import { formatDate } from '@/utils/date';

export default {
  name: 'BookingPeriod',

  props: {
    start: {
      type: String,
      required: true,
    },

    end: {
      type: String,
      required: false,
      default: null,
    },
  },

  methods: {
    formatDate,
  },
};
</script>
